import { render, staticRenderFns } from "./CouponCard.vue?vue&type=template&id=5a10f69a&scoped=true&"
import script from "./CouponCard.vue?vue&type=script&lang=js&"
export * from "./CouponCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponCard.vue?vue&type=style&index=0&id=5a10f69a&scoped=true&lang=css&"
import style1 from "./CouponCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a10f69a",
  null
  
)

export default component.exports